export default __webpack_public_path__ + "static/media/learose4-1024w.1e98b9c4.png";